import request from '@/utils/request'
import host from '@/api/base/host'

// 分期
const port = 'dev'
// const port = 'test:ljs'
const installment = host.path(port, { dev: 'v1/installment', test: 'v1/installment' })
const order = host.path(port, { dev: 'v1/order', test: 'v1/order' })
const order2 = host.path(port, { dev: 'v2/order/h5', test: 'v2/order/h5' })

export default {
  // 获根据月份取我的分期
  getPayPlan(data) {
    const { date } = data
    return request({
      url: installment('getPayPlanByUserId'),
      method: 'post',
      data: { date }
    })
  },
  // 获取用户分期状态
  getPayPlanStatus(data) {
    return request({
      url: installment('getPayPlanInfoByUserId'),
      method: 'post',
      data
    })
  },
  // 根据年获取我的分期
  getYearInstallment(data) {
    const { date } = data
    return request({
      url: installment('getYearInstallmentByUserId'),
      method: 'post',
      data: { date }
    })
  },
  // 根据订单获取分期详情列表
  getInstallmentList(data) {
    return request({
      url: installment('getInstallmentByOrderSn'),
      method: 'post',
      data
    })
  },
  // 获取逾期的订单的列表
  getOverdueOrderList(data) {
    return request({
      url: installment('getOverdueOrderList'),
      method: 'post',
      data
    })
  },

  // 根据订单编号的分期订单合并付款
  mergePaymentByOrderSn(data) {
    return request({
      url: order2('mergePaymentByOrderSn'),
      method: 'post',
      data
    })
  },
  // 年度进行分期订单合并付款
  mergePaymentByYear(data) {
    return request({
      url: order2('mergePaymentByYear'),
      method: 'post',
      data
    })
  },
  // 月度分期订单的合并付款
  mergePaymentByMonth(data) {
    return request({
      url: order2('mergePaymentByMonth'),
      method: 'post',
      data
    })
  },
  // 逾期的订单合并付款
  mergePaymentByOverdue(data) {
    return request({
      url: order2('mergePaymentByOverdue'),
      method: 'post',
      data
    })
  },
  // 多笔分期合并支付
  mergePaymentByPayPlanSnList(data) {
    return request({
      url: order2('mergePaymentByPayPlanSnList'),
      method: 'post',
      data
    })
  },
  // 取消上一笔分期支付
  clearCache(data) {
    return request({
      url: order('clearCache'),
      method: 'post',
      data
    })
  },
  
  // 分期的还款
  payment(data) {
    return request({ url: order2('payment'), method: 'post', data })
  }
}
